import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class LeadService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'lead';
    this.token = new Login();
  }

  all(page = 1, buscar = '', paginate = 10){
    return this.http.get<Object[]>(this.url + '?page=' + page + '&q=' + buscar + '&paginate=' + paginate, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  excluir(id: any){
    return this.http.delete<Object[]>(this.url + '/' + id, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  inativar(id: any){
    return this.http.post<Object[]>(this.url + '/inativar/' + id,{}, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  ativar(id: any){
    return this.http.post<Object[]>(this.url + '/ativar/' + id, {},{
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}
